













import { defineComponent, computed } from '@vue/composition-api'
export default defineComponent({
  name: 'banner',
  props: {
    inSelfGray: {
      type: Boolean,
      default: false
    },
    bannerImg: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const bannerUrl = computed(() => {
      if (props.bannerImg) return props.bannerImg
      return props.inSelfGray
        ? 'https://dpubstatic.udache.com/static/dpubimg/2vp_xgr0sLQv24CAisj2q.png'
        : 'https://dpubstatic.udache.com/static/dpubimg/x7kimydkmpUlqHP_SMI9b.png'
    })
    return {
      bannerUrl
    }
  }
})
